export const theme = {
	fontFamily: '"PT Sans", sans-serif',
}
